module.exports = __webpack_public_path__ + "img/icon1.6bde08b6.png";